import styled from 'styled-components';

export const Container = styled.div`
  margin-left: auto;
  margin-right: auto;
`;

export const Main = styled.main`
  margin-left: auto;
  margin-right: auto;
`;

export const Header = styled.header`
  margin-left: auto;
  margin-right: auto;
`;
